<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.id"
        placeholder="请输入ID"
        clearable
        size="small"
        class="param-input"
        style="width: 220px"
      ></el-input>
      <el-input
        v-model="params.uid"
        placeholder="请输入用户ID"
        clearable
        size="small"
        class="param-input"
        style="width: 220px"
      ></el-input>
      <el-input
        v-model="params.name"
        placeholder="请输入专题名称"
        clearable
        size="small"
        class="param-input"
        style="width: 280px"
      ></el-input>
      <el-select
        placeholder="请选择是否开启"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择是否推荐"
        clearable
        size="small"
        v-model="params.isRecommend"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in isRecommendes"
          :key="item.value"
        ></el-option>
      </el-select>
      <!-- <el-select
        placeholder="请选择模块"
        clearable
        size="small"
        v-model="sectionList"
      >
        <el-option
          :label="item.name"
          :value="item.section"
          v-for="item in modulesList"
          :key="item.id"
          @change="searchSelectSection"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择专题"
        clearable
        size="small"
        v-model="params.cid"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="item in sectionList"
          :key="item.id"
        ></el-option>
      </el-select> -->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        :disabled="isDisabled"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        :disabled="isDisabled"
        >新增</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchSet()"
        :disabled="isDisabled"
        >批量审核</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchAddSection()"
        :disabled="isDisabled"
        >批量设置专题</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @selection-change="handleSelectionChange"
      height="600"
    >
      <el-table-column
        type="selection"
        v-if="isSelection"
        width="55"
        fixed="left"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="uid" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center" width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cover" label="封面图" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.cover">暂无封面图</span>
          <div
            v-else
            class="picturePreview"
          >
            <img-load
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.cover"
              fit="fill"
            ></img-load>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 1">图集</el-tag>
          <el-tag type="success" v-else-if="scope.row.type == 2">视频</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="合集价格" align="center" min-width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="合集期数" align="center" min-width="140"></el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isRecommend"
        label="是否推荐"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isRecommend">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 0">待审核</el-tag>
          <el-tag type="success" v-else-if="scope.row.status == 1"
            >审核通过</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.status == 2">下架</el-tag>
          <el-tag type="success" v-else-if="scope.row.status == 3"
            >审核失败</el-tag
          >
          <el-tag v-else>--</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="collectCount"
        label="收藏数量"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.collectCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="count" label="合集数量" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.count || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="排序" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAct"
        label="操作人"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-view"
            @click="viewResource(scope.row)"
            >查看资源</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="bottom">
      <!--批量上下架-->
      <div class="btn" v-if="isSelection">
        <el-button type="info" size="mini" @click="giveUp">放弃操作</el-button>
        <el-button type="primary" size="mini" @click="subSection"
          >提交</el-button
        >
      </div>
      <div class="page">
        <el-pagination
          :page-sizes="[10, 25, 50, 100]"
          :current-page="params.pageNumber"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          v-if="total > 10"
          @size-change="changeSize"
          @current-change="changeCurrent"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          label="名称:"
          size="small"
          prop="name"
          style="width: 480px"
        >
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          label="描述:"
          size="small"
          prop="desc"
          style="width: 480px"
        >
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="封面图:"
          prop="cover"
          style="width: 480px"
        >
          <base-upload
            :cover="form.cover"
            :action="uploadUrl"
            @successCallback="uploadPortrait"
            :width="'120px'"
            :height="'120px'"
            :hide="true"
          ></base-upload>
        </el-form-item>
        <el-form-item
          size="small"
          label="类型:"
          prop="type"
          style="width: 480px"
        >
          <el-select
            v-model="form.type"
            placeholder="请选择类型"
            :disabled="dialogTitle != '新增'"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in types"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="合集价格:"
          prop="sortCode"
          style="width: 480px"
        >
          <el-input v-model.number="form.price" placeholder="请输入合集价格"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="合集期数:"
          prop="remark"
          style="width: 480px"
        >
          <el-input v-model="form.remark" placeholder="请输入合集期数"></el-input>
        </el-form-item>
        <el-form-item
          label="用户ID:"
          size="small"
          prop="uid"
          style="width: 480px"
        >
          <el-input v-model.number="form.uid"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="排序:"
          prop="sortCode"
          style="width: 480px"
        >
          <el-input v-model.number="form.sortCode"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="是否推荐:"
          prop="isRecommend"
          style="width: 480px"
        >
          <el-select v-model="form.isRecommend" placeholder="请选择是否推荐">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in isRecommendes"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="状态:"
          prop="status"
          style="width: 480px"
        >
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statuses"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog title="批量设置状态" :visible.sync="isBatchStaus" @close="close">
      <el-form ref="form" label-width="110px">
        <el-form-item label="审核状态:">
          <el-select
            v-model="reviewStatus"
            placeholder="请选择状态"
            size="small"
          >
            <el-option
              v-for="item in reviewStaList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSet" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="isBatchDeleteLoading"
          @click="confirmSet()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="批量添加专题"
      :visible.sync="isBatchAddSection"
      @close="close"
    >
      <el-form ref="form" label-width="110px">
        <el-form-item label="专题ID:">
          <el-input v-model="sectionId"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAddSection" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="isBatchDeleteLoading"
          @click="confirmAddSection()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <ResourceDialog ref="resourceDialogRef" />
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import ResourceDialog from "./components/ResourceDialog.vue";

export default {
  components: {
    ResourceDialog,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      imgUrl: baseConfig.imgUrl,
      // 列表数据
      tableData: [],
      // 模块列表数据
      modulesList: [],
      // 专题列表数据
      sectionList: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        status: undefined, // 状态
        isRecommend: undefined, // 是否推荐
        id: undefined, // id
        uid: undefined, // uid
        name: undefined, // 专题名称
        cid: undefined, // 模块id
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        cover: [{ required: true, message: "请上传图片", trigger: "blur" }],
        uid: [{ required: true, message: "请输入用户ID", trigger: "blur" }],
      },
      types: [
        {
          label: "图集",
          value: 1,
        },
        {
          label: "视频",
          value: 2,
        },
      ],
      statuses: [
        { label: "待审核", value: 0 },
        { label: "开启(审核通过)", value: 1 },
        { label: "关闭(下架)", value: 2 },
        { label: "审核失败", value: 3 },
      ],
      isRecommendes: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        name: undefined, // 名称
        cover: undefined, // 封面图
        type: 1, // 类型
        uid: undefined, // 用户ID
        isRecommend: false, // 是否推荐
        sortCode: 0, // 排序
        status: 1, // 状态
        cid: undefined, // 模块id
        desc: undefined, // 描述
        price: null,
        remark: '', // 期数
      },
      isSelection: false,
      isDisabled: false,
      isBatchStaus: false,
      reviewStatus: undefined,
      isBatchDeleteLoading: false,
      reviewStaList: [
        { label: "待审核", value: 0 },
        { label: "审核通过", value: 1 },
        { label: "下架", value: 2 },
        { label: "审核失败", value: 3 },
      ],
      videoIds: [],
      batchContent: "",
      isBatchAddSection: false,
      sectionId: undefined,
    };
  },
  created() {
    this.getList();
    this.getSectionList();
  },
  methods: {
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.videoIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.videoIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      let tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.videoIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.videoIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.videoIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.videoIds = this.videoIds.concat(objArr);
      const tempVideos = new Set(this.videoIds);
      this.videoIds = Array.from(tempVideos);
    },
    batchSet() {
      this.isSelection = true;
      this.isDisabled = true;
    },
    batchAddSection() {
      this.batchContent = "addSection";
      this.isSelection = true;
      this.isDisabled = true;
    },
    giveUp() {
      this.isDisabled = false;
      this.isSelection = false;
      this.isBatchStaus = false;
      this.isBatchAddSection = false;
      this.videoIds = [];
    },
    subSection() {
      if (this.videoIds.length == 0) {
        this.$message.error("请至少选择一条数据");
        return;
      }
      if (this.batchContent == "addSection") {
        this.isBatchAddSection = true;
      } else {
        this.isBatchStaus = true;
      }
    },
    cancelSet() {
      this.isBatchStaus = false;
    },
    cancelAddSection() {
      this.isBatchAddSection = false;
    },
    async confirmSet() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
        status: this.reviewStatus,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.batchEditSta(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "设置成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getList();
      } else {
        this.$message.error("设置失败！");
      }
    },
    async confirmAddSection() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        ids: videoIDs,
        cid: this.sectionId,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.batchAddSection(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "设置成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getList();
      } else {
        this.$message.error("设置失败！");
      }
    },
    close() {
      this.reviewStatus = undefined;
      this.sectionId = undefined;
    },
    // 头像上传成功
    uploadPortrait(res) {
      this.form.cover = res.data.coverImg;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getPlaylistList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //查询模块列表数据
    getSectionList() {
      var params = {
        pageNumber: 1,
        pageSize: 1000,
      };
      API.getAllModulesSection(params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.modulesList = res.data;
          } else {
            this.modulesList = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    searchSelectSection() {
      this.form.cid = undefined;
    },
    // 新增
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        Object.assign(this.form, param)
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addPlaylist(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updatePlaylist(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delPlaylist(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    viewResource(row) {
      this.$refs.resourceDialogRef.open(row);
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.form.cover = undefined;
      this.form.type = 1;
      this.form.uid = 0;
      this.form.isRecommend = false;
      this.form.sortCode = 0;
      this.form.status = 1;
      this.form.cid = undefined;
      this.form.desc = undefined;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
.bottom {
  margin-top: 20px;

  .btn {
    display: inline-block;
    margin-left: 20px;
  }

  .page {
    display: inline-block;
    float: right;
  }
}

.el-pagination {
  margin-top: 0 !important;
}
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  margin-top: 20px;
}
</style>
